//普通工具
const generalUtil = {
    decodeHtml: function (arg) {
        var m = {
            "&lt;": "<",
            "&gt;": ">",
            "&amp;": "&",
            "&nbsp;": " ",
            "&quot;": '"',
            "&copy;": "",
            "&apos;": "'"
        };
        return (typeof arg != "string") ? arg : arg.replace(/&\w+;|&#(\d+);/g,
          function (o, n) {
              var p = m[o];
              if (p === undefined) {
                  if (!isNaN(n)) {
                      p = String.fromCharCode((n == 160) ? 32 : n);
                  } else {
                      p = o;
                  }
              }
              return p;
          })
    },
    isUnsignedNumeric: function (number) {
        if (objectUtil.isEmpty(number)) {
            return false;
        }
        var req = /^\d+(\.\d+)?$/;
        return req.test(number);
    },
    isInteger: function (number) {
        if (objectUtil.isEmpty(number)) {
            return false;
        }
        var req = /^(-     |\+)?\d+$/;
        return req.test(number);
    },
    isUnsignedInteger: function (number) {
        var req = /^\d+$/;
        return req.test(number);
    },
    isFloat: function (number) {
        if (objectUtil.isEmpty(number)) {
            return false;
        }
        var req = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        return req.test(number);
    },
    isPhoneNum: function (phone) {
        if (objectUtil.isEmpty(phone)) {
            return false;
        }
        var req = /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(14[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
        return req.test(phone);
    },
    isPhone: function (phone) {
        if (objectUtil.isEmpty(phone)) {
            return false;
        }
        var req = /^(0\\d{2}-\\d{8}(-\\d{1,4})?)|(0\\d{3}-\\d{7,8}(-\\d{1,4})?)$/;
        return req.test(phone);
    },
    isEmail: function (email) {
        if (objectUtil.isEmpty(email)) {
            return false;
        }
        var req = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        return req.test(email);
    },
    //转换为金额
    changePrice: function (price) {
        if (price !== "" && price !== 0) {
            return price.toFixed(2);
        }
        else {
            return "0.00";
        }
    },
    isNumber: function (val) {
        return /^[\d]+$/.test(val);
    },
    hasSpace: function (arg) {
        if (val == undefined || val == null || val == "null" || val == "undefined") {
            return true
        }
        return arg.indexOf("") > -1
    },
    SubString: function (val, length) {
        if (val != null && val != undefined && val != '') {
            if (val.length > length) {
                return val.substr(0, length) + '...';
            } else {
                return val.substr(0, length);
            }
        } else {
            return '';
        }

    },
    isEmpty: function (val) {
        if (val == undefined || val == null || val == "") {
            return true;
        }
        return false;
    },
    trim: function (str) { //删除左右两端的空格
        return str.replace(/(^\s*)|(\s*$)/g, ""); //把空格替换为空
    },
    //获取当前的x坐标值
    pageX: function (elem) {
        return elem.offsetParent ? (elem.offsetLeft + this.pageX(elem.offsetParent)) : elem.offsetLeft;
    },
    //获取当前的Y坐标值
    pageY: function (elem) {
        return elem.offsetParent ? (elem.offsetTop + this.pageY(elem.offsetParent)) : elem.offsetTop;
    },
    //生成唯一标识
    getGuid: function () {
        function uuid() {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
            // s[8] = s[13] = s[18] = s[23] = "-";
            s[8] = s[13] = s[18] = s[23] = "";

            var uuid = s.join("");
            return uuid;
        }

        var timestamp = new Date().getTime();
        // var guid=uuid()+"-"+timestamp;
        var guid = uuid();
        return guid;
    },
    genReportId: function () {
        try {
            var reportId = M.cookie.getCookie('reportGid');
            if (!M.string.isEmpty(reportId)) {
                var reportArr = reportId.split('=');
                if (reportArr.length == 2) {
                    return reportArr[1];
                } else {
                    var guid = M.string.getGuid();
                    M.cookie.setCookie('reportGid', guid, 1000, '', 'www.labtaobao.com.com');
                    return guid;
                }
            } else {
                var guid = M.string.getGuid();
                M.cookie.setCookie('reportGid', guid, 1000, '', 'www.labtaobao.com.com');
                return guid;
            }
        } catch (e) {
            return '';
        }
    },
    //获取加密
    getSymmet: function () {
        return '123123AD@$@3@#!'
    },
};
const MBrowserUtil = function(){
    var osObj = null;
    var mobile = null;
    function getOsInfo(){
        var navi = navigator.userAgent;
        osObj = {},
          mobile = {};
        var webkit = navi.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
          android = navi.match(/(Android);?[\s\/]+([\d.]+)?/),
          mac = !!navi.match(/\(Macintosh\; Intel /),
          ipad = navi.match(/(iPad).*OS\s([\d_]+)/),
          ipod = navi.match(/(iPod)(.*OS\s([\d_]+))?/),
          iphone =!ipad && navi.match(/(iPhone\sOS)\s([\d_]+)/),
          webos = navi.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
          touchpad = webos && navi.match(/TouchPad/),
          kindle = navi.match(/Kindle\/([\d.]+)/),
          blackBerry = navi.match(/(BlackBerry).*Version\/([\d.]+)/),
          bb = navi.match(/(BB10).*Version\/([\d.]+)/),
          playBook = navi.match(/PlayBook/),
          chrome = navi.match(/Chrome\/([\d.]+)/) || navi.match(/CriOS\/([\d.]+)/),
          firefox = navi.match(/Firefox\/([\d.]+)/),
          msie = navi.match(/MSIE\s([\d.]+)/) || navi.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
          webview = !chrome && navi.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
          safari = webview || navi.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/),
          weixin = navi.indexOf("MicroMessenger") >=0;
        qq = navi.indexOf("QQ/")>=0;
        qqBrowser=navi.indexOf("MQQBrowser")>=0;
        weibo = navi.indexOf("Weibo") >=0;
        app= navi.indexOf("KidsTC") >=0;
        uc=navi.indexOf("UCBrowser") >=0;
        if(webkit){
            mobile.browser = "webkit";
            mobile.version = webkit[1];
        }
        if(android){
            osObj.os = "android";
            osObj.version = android[2];
        }
        if(iphone && !ipod){
            osObj.os = "ios";
            osObj.client = "iphone";
        }
        if(ipad){
            osObj = "ios";
            osObj = "ipad";
        }
        if(ipod){
            osObj.os = "ios";
            osObj.client = "ipod";
            osObj.version = ipod[3] ? ipod[3].replace(/_/g, ".") : null;
        }
        if(webos){
            osObj.os = "webos";
            osObj.version = webos[2];
        }
        if(touchpad){
            osObj.os = "touchpad";
        }
        if(blackBerry){
            osObj.os = "blackberry";
            osObj.version = blackBerry[2];
        }
        if(chrome){
            mobile.browser = "chrome";
            mobile.version = chrome[1];
        }
        if(firefox){
            mobile.browser = "firefox";
            mobile.version = firefox[1];
        }
        if(msie){
            mobile.browser = "ie";
            mobile.version = msie[1];
        }
        if(safari && (mac || osObj.client=="ios")){
            mobile.browser = "safari";
            if(mac){
                mobile.version = safari[1];
            }
        }
        if(webview){
            mobile.browser = "webview";
        }
        if(weixin){
            mobile.browser = "weixin";
        }else if(qq){
            mobile.browser = "qq";
        }else if(weibo){
            mobile.browser = "weibo";
        }else if(uc){
            mobile.browser = "uc";
        }else if(qqBrowser){
            mobile.browser = "qqBrowser";
        }
        if(app){
            mobile.browser = "webkit";
        }
        osObj.tablet = !!(ipad || playBook || (android && !navi.match(/Mobile/)) || (firefox && navi.match(/Tablet/)) || (msie && !navi.match(/Phone/) && navi.match(/Touch/)));
        osObj.phone = !!(!osObj.tablet && (!osObj.client=="ipod") && (android || iphone || webos || blackBerry || bb || (chrome && navi.match(/Android/)) || (chrome && navi.match(/CriOS\/([\d.]+)/)) || (firefox && navi.match(/Mobile/)) || (msie && navi.match(/Touch/))));
        osObj.os = osObj.os || null;
        osObj.version = osObj.version || null;
        osObj.client = osObj.client || null;
        osObj.tablet = osObj.tablet || null;
        osObj.phone = osObj.phone || false;
        osObj.isAppWebkit=app||false;
        osObj.isAndoridApp=(app&&osObj.os=='android')?true:false;
        osObj.isIosApp=(app&&osObj.os=='ios')?true:false;
        osObj.isAndorid=(osObj.os=='android')?true:false;
        osObj.isIos=(osObj.os=='ios')?true:false;
        osObj.isUcApp=uc||false;
        osObj.isQQBrowser=qqBrowser&&!qq||false;
        osObj.isWeiXinApp=weixin||false;
        osObj.isWeiBoApp=weibo||false;
        osObj.isQQApp=qq||false;
        mobile.browser = mobile.browser || null;
        mobile.version = mobile.version || null;
    }
    function runGetOsInfo(){
        if(!osObj || !mobile){
            getOsInfo();
        }
        return osObj;
    }

    function isApp(){
        var browserOs=runGetOsInfo();
        return browserOs.isAppWebkit;
    }

    function isAndroidApp(){
        var browserOs=runGetOsInfo();
        return browserOs.isAndoridApp;
    }

    function isIosApp(){
        var browserOs=runGetOsInfo();
        return browserOs.isIosApp;
    }

    function isAndroid(){
        var browserOs=runGetOsInfo();
        return browserOs.isAndorid;
    }

    function isIos(){
        var browserOs=runGetOsInfo();
        return browserOs.isIos;
    }

    function isUcApp(){
        var browserOs=runGetOsInfo();
        return browserOs.isUcApp;
    }

    function isWeiXinApp(){
        var browserOs=runGetOsInfo();
        return browserOs.isWeiXinApp;
    }

    function isWeiBoApp(){
        var browserOs=runGetOsInfo();
        return browserOs.isWeiBoApp;
    }

    function isQQApp(){
        var browserOs=runGetOsInfo();
        return browserOs.isQQApp;
    }

    function runGetBrowserInfo(){
        if(!osObj || !mobile){
            getOsInfo();
        }
        return mobile;
    }
    function setAddressMap(){
        navigator.geolocation.getCurrentPosition(function (p) {
              var latitude = p.coords.latitude//纬度
              var longitude = p.coords.longitude;
              var map = longitude + ',' + latitude;
              base.locastorage.remove('map_address');
              //记录地址到缓存
              base.locastorage.set('map_address', map);
              //base.cookie.setCookie('mapaddr',map,30,'','www.labtaobaobao.com');
          }, function (e) {//错误信息

          }, {
              enableHighAccuracy:true,
              maximunAge:1000,
              timeout:5000
          }
        );
    }
    function getAddressMap(){
        return base.locastorage.get('map_address');
    }
    function getSelectAgeType(){
        var type=base.locastorage.get('select_age_type');
        if(type==null||type==''||type==undefined){
            runSelectAgeType();
            return null;
        }
        return type.split(',');
    }
    function getAgeType(){
        var type=base.locastorage.get('select_age_type');
        if(type==null||type==''||type==undefined){
            return null;
        }
        return type.split(',');
    }
    function runSelectAgeType(){
        var oHead = document.getElementsByTagName('HEAD').item(0);
        var oScript= document.createElement("script");
        oScript.type = "text/javascript";
        /*oScript.src="/js/tools/changediv/js/runselecttype.js";*/
        oScript.src="/js/tools/changeAge/js/runchangeage.js";
        oHead.appendChild(oScript);
    }
    function setSelectAgeType(type){
        base.locastorage.remove('select_age_type');
        //记录地址到缓存
        base.locastorage.set('select_age_type', type);
    }
    return {
        getOS: runGetOsInfo,
        getBrowser: runGetBrowserInfo,
        setAddressMap:setAddressMap,
        getAddressMap:getAddressMap,
        getSelectAgeType:getSelectAgeType,
        setSelectAgeType:setSelectAgeType,
        getAgeType:getAgeType,
        runSelectAgeType:runSelectAgeType,
        isApp:isApp,
        isAndoridApp:isAndroidApp,
        isIosApp:isIosApp,
        isUcApp:isUcApp,
        isWeiXinApp:isWeiXinApp,
        isWeiBoApp:isWeiBoApp,
        isQQApp:isQQApp,
        isAndroid:isAndroid,
        isIos:isIos
    }
};
//本地存储工具-localStorage
const MLocalStorageUtil = function(){
    var isexist = window.localStorage ? true :false;
    if(isexist){
        try{
            window.localStorage.setItem("base_test",1);
        }catch(e){
            isexist = false;
            base.log("localStorage无法set","error");
        }
        try{
            window.localStorage.getItem("base_test");
        }catch(e){
            isexist = false;
            base.log("localStorage无法get","error");
        }
        try{
            window.localStorage.removeItem("base_test");
        }catch(e){
            isexist = false;
            base.log("localStorage无法remove","error");
        }
    }
    function getStorage(key){
        var storage = null;
        if(isexist && key){
            storage = window.localStorage.getItem(key);
        }
        return storage;
    }
    function setStorage(key,value){
        if(isexist && key){
            try{
                window.localStorage.setItem(key,value);
            }catch(e){
                MLocalStorageUtil.removeAllStorage();
                window.localStorage.setItem(key,value);
            }
        }
    }
    function reomveSotrage(key){
        if(isexist && key){
            window.localStorage.removeItem(key);
        }
    }
    function removeAllStorage(){
        if(isexist){
            objectUtil.each(window.localStorage,function(key){
                window.localStorage.removeItem(key);
            });
        }
    }
    return {
        get: getStorage,
        set: setStorage,
        remove: reomveSotrage,
        removeAll: removeAllStorage
    }
};
//本地存储工具-sessionStorage
const MSessionStorageUtil=function(){
    var isexist = window.sessionStorage ? true :false;
    if(isexist){
        try{
            window.sessionStorage.setItem("base_test",1);
        }catch(e){
            isexist = false;
            base.log("localStorage无法set","error");
        }
        try{
            window.sessionStorage.getItem("base_test");
        }catch(e){
            isexist = false;
            base.log("localStorage无法get","error");
        }
        try{
            window.sessionStorage.removeItem("base_test");
        }catch(e){
            isexist = false;
            base.log("localStorage无法remove","error");
        }
    }
    function getStorage(key){
        var storage = null;
        if(isexist && key){
            storage = window.sessionStorage.getItem(key);
        }
        return storage;
    }
    function setStorage(key,value){
        if(isexist && key){
            try{
                window.sessionStorage.setItem(key,value);
            }catch(e){
                MSessionStorageUtil.removeAllStorage();
                window.sessionStorage.setItem(key,value);
            }
        }
    }
    function reomveSotrage(key){
        if(isexist && key){
            window.sessionStorage.removeItem(key);
        }
    }
    function removeAllStorage(){
        if(isexist){
            objectUtil.each(window.sessionStorage,function(key){
                window.sessionStorage.removeItem(key);
            });
        }
    }
    return {
        get: getStorage,
        set: setStorage,
        remove: reomveSotrage,
        removeAll: removeAllStorage
    }
};
//对象工具
const objectUtil = {
    merge: function (target, source, isarr) {
        if (!target || !source || typeof source != "object") {
            return target;
        }
        if (!isarr) {
            for (var i in source) {
                target[i] = source[i];
            }
        } else {
            var tproperty, sproperty;
            for (tproperty in source) {
                if (source.hasOwnProperty(tproperty)) {
                    sproperty = source[tproperty];
                    if (sproperty && sproperty.constructor === Object) {
                        if (source[tproperty] && source[tproperty].constructor === Object) {
                            objectUtil.merge(target[tproperty], sproperty);
                        } else {
                            target[tproperty] = sproperty;
                        }
                    } else {
                        target[tproperty] = sproperty;
                    }
                }
            }
        }
        return target;
    },
    clone: function (source, isarr) {
        return objectUtil.merge({}, source, isarr);
    },
    namespace: function () {
        var namespaceObj = arr, subObj;
        for (var i = 0; i < arguments.length; i++) {
            var tmp = arguments[i];
            if (objectUtil.$mTcObj.namespace[tmp]) {
                continue;
            }
            arr = tmp.split(".");
            for (var j = 0; j < arr.length; j++) {
                subObj = arr[j];
                if (!namespaceObj[subObj]) {
                    namespaceObj[subObj] = {};
                }
                namespaceObj = namespaceObj[subObj];
            }
            objectUtil.$mTcObj.namespace[tmp] = true;
        }
    },
    extend: function () {
        var l = function (p) {
            for (var n in  p) {
                if (!p.hasOwnProperty(n)) {
                    continue;
                }
                this[n] = p[n];
            }
        };
        return function (p, o) {
            (typeof p == "function") || (p = function () {
            });
            var m = function () {
                p.apply(this, arguments);
            }
            var n = function () {
            };
            n.prototype = p.prototype;
            m.prototype = new n();
            m.prototype.constructor = m;
            m.superclass = p.prototype;
            if (p.prototype.constructor === Object.prototype.constructor) {
                p.prototype.constructor = p;
            }
            m.override = function (r) {
                if (m.prototype && r && typeof r == "object") {
                    for (var q in r) {
                        m.prototype[q] = r[q];
                    }
                }
            };
            m.prototype.override = l;
            m.override(o);
            return m;
        }
    }(),
    each: function (obj, func, otherobj) {
        if (objectUtil.isEmpty(obj) || !func) {
            return;
        }
        if (objectUtil.isArray(obj)) {
            for (var i = 0; i < obj.length; i++) {
                try {
                    if (func.call(otherobj, obj[i], i, obj) === false) {
                        return;
                    }
                } catch (e) {
                    base.log(e, "error");
                }
            }
        } else {
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) {
                    continue;
                }
                try {
                    if (func.call(otherobj, obj[i], i, obj) === false) {
                        return;
                    }
                } catch (e) {
                    //记录日志
                    base.log(e, "error");
                }
            }
        }
    },
    contains: function (obj, value) {
        if (objectUtil.isArray(obj)) {
            if ("indexOf" in Array.prototype) {
                return obj.indexOf(value) != -1;
            }
            for (var i = 0; i < obj.length; i++) {
                if (obj[i] === value) {
                    return true;
                }
            }
            return false;
        } else {
            return !objectUtil.isEmpty(obj) && value in obj;
        }
    },
    isEmpty: function (obj) {
        if ((typeof obj === "undefined") || (obj === null) || (objectUtil.isArray(obj) && obj.length === 0)) {
            return true;
        } else {
            if (objectUtil.isObject(obj)) {
                for (var i in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, i)) {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
    },
    //判断是否是对象
    isObject: function (obj) {
        if (Object.prototype.toString(null === "[object Object]")) {
            return obj != null && obj != undefined && Object.prototype.toString.call(obj) === "[object Object]" && obj.ownerDocument === undefined;
        } else {
            return Object.prototype.toString.call(obj) === "[object Object]";
        }
    },
    isBlank: function (obj) {
        return objectUtil.isEmpty(obj) ? true : objectUtil.isEmpty(String(obj).replace(/^\s+|\s+$/g, ""));
    },
    isDefined: function (obj) {
        return typeof obj === "undefined";
    },
    //判断是否是方法
    isFunction: function (obj) {
        return Object.prototype.toString.apply(obj) === "[object Function]";
    },
    isArray: function (obj) {
        return Object.prototype.toString.apply(obj) === "[object Array]";
    },
    isDate: function (obj) {
        return Object.prototype.toString.apply(obj) === "[object Date]";
    },
    isNumber: function (obj) {
        return typeof obj === "number" && isFinite(obj);
    },
    isString: function (obj) {
        return typeof obj === "string";
    },
    isBoolean: function (obj) {
        return typeof obj === "boolean";
    },
    isName: function (obj) {
        var patrn = /^\s*[\u4e00-\u9fa5]{1,}[\u4e00-\u9fa5.·]{0,15}[\u4e00-\u9fa5]{1,}\s*$/;
        if (!patrn.exec(obj)) {
            return false;
        }
        return true;
    },
    isMobile: function (val) {
        return /^\d{11}$/.test(val);
    },
    JsonToString: function (obj) {
        switch (typeof(obj)) {
            case 'string':
                return '"' + obj.replace(/(["\\])/g, '\\$1') + '"';
            case 'array':
                return '[' + obj.map(objectUtil.JsonToString).join(',') + ']';
            case 'object':
                if (obj instanceof Array) {
                    var strArr = [];
                    var len = obj.length;
                    for (var i = 0; i < len; i++) {
                        strArr.push(objectUtil.JsonToString(obj[i]));
                    }
                    return '[' + strArr.join(',') + ']';
                } else if (obj == null) {
                    return 'null';

                } else {
                    var string = [];
                    for (var property in obj) string.push(objectUtil.JsonToString(property) + ':' + objectUtil.JsonToString(obj[property]));
                    return '{' + string.join(',') + '}';
                }
            case 'number':
                return obj;
            case false:
                return obj;
            default:
                return obj;
        }
    }
};
//封装cookie
const MCookieUtil = {
    getCookie:function(key){
        var startIndex = document.cookie.indexOf(key+"=");
        if(startIndex==-1){
            return null;
        }
        startInex = startIndex+name.length+1;
        var endIndex = document.cookie.indexOf(";",startIndex);
        if(endIndex==-1){
            endIndex = document.cookie.length;
        }
        var value = document.cookie.substring(startIndex,endIndex);
        return unescape(value);
    },
    setCookie:function(key,value,time,ph,dm){
        var tcookie = key+"="+escape(value);
        if(time!=""){
            var date = new Date();
            date.setTime(date.getTime() + time * 24 * 3600 * 1000);
            tcookie +=";expires="+date.toGMTString();
        }
        if(ph!=""){
            tcookie+=":path="+ph;
        }
        if(dm!=""){
            tcookie+=";domain="+dm;
        }
        document.cookie = tcookie;
    },
    removeCookie:function(key){
        var date = new Date();
        date.setTime(date.getTime()-1);
        document.cookie = key+"=; expires="+date.toGMTString();
    }
};
//日期工具
const  MDateUtil = {
    toString:function(date,format){
        var result = undefined;
        var years = date.getFullYear();
        var months = date.getMonth()+1;
        var dates  = date.getDate();
        var hours = date.getHours();
        var mins =  date.getMinutes();
        var secs =  date.getSeconds();
        months = (parseInt(months) < 10) ? ("0"+months):(months);
        dates = (parseInt(dates) <10 ) ? ("0" + dates):(dates);
        hours = (parseInt(hours)<10) ? ("0"+hours):(hours);
        mins = (parseInt(mins) < 10) ? ("0" + mins):(mins);
        secs = (parseInt(secs)<10) ? ("0"+secs):(secs);
        if("yyyy-MM-dd HH:mm:ss"==format){
            result = years+"-"+months+"-"+dates+" "+hours+":"+mins+":"+secs;
        }else{
            if("yyyy-MM-dd"==format){
                result = years+"-"+months+"-"+dates;
            }else{
                if("yyyy-MM"==format){
                    result = years+"-"+months;
                }else{
                    result = years;
                }
            }
        }
        return result;
    },
    toDate:function(dateStr){
        if(dateStr.length==19){
            var year = dateStr.substring(0,4);
            var month = dateStr.substring(5,7);
            var date = dateStr.substring(8,10);
            var hour = dateStr.substring(11,13);
            var minute = dateStr.substring(14,16);
            var second = dateStr.substring(17,19);
            return new Date(year,month-1,date,hour,minute,second);
        }else{
            if(dateStr.length==10){
                var year = dateStr.substring(0,4);
                var month = dateStr.substring(5,7);
                var date = dateStr.substring(8,10);
                return new Date(year,month-1,date);
            }else {
                if(dateStr.length==7){
                    var year = dateStr.substring(0,4);
                    var month = dateStr.substring(5,7);
                    return new Date(year,month-1);
                }else{
                    if(dateStr.length==4){
                        var year = dateStr.substring(0,4);
                        return new Date(year);
                    }else{
                        return undefined;
                    }
                }
            }
        }
    },
    getMonthDays:function(date,month){
        var dayArray = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
        var year = date.getFullYear();
        if(typeof month == "undefined"){
            month = date.getMonth();
        }
        if(((0 == (year % 4)) && ((0 != (year % 100)) || (0 == (year % 400)))) && month == 1){
            return 29;
        }else{
            return dayArray[month];
        }
    },
    today:function(format){
        if(arguments.length==0){
            return MDateUtil.toString(new Date(),"yyyy-MM-dd");
        }else{
            return MDateUtil.toString(new Date(),format);
        }
    },
    addDays:function(day,dateStr){
        var tmp = (arguments.length==1)?MDateUtil.toDate(MDateUtil.today()):MDateUtil.toDate(dateStr);
        tmp = new Date(tmp.getTime()+parseInt(day)*24*3600*1000);
        return MDateUtil.toString(new Date(tmp),"yyyy-MM-dd HH:mm:ss");
    },
    addMonths:function(month,dateStr){
        var tmp = (arguments.length==1)? MDateUtil.toDate(MDateUtil.today()):MDateUtil.toDate(dateStr);
        var months = tmp.getMonth();
        var nowdays = tmp.getDate();
        var afterdays = MDateUtil.getMonthDays(tmp,tmp.getMonth()+parseInt(month));
        if(nowdays>afterdays){
            tmp.setDate(afterdays);
        }
        tmp.setMonth(tmp.getMonth()+parseInt(month));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    //每个月第一天
    firstDayOfMonth:function(dateStr){
        var tmp = (arguments.length==0) ? MDateUtil.toDate(MDateUtil.today()):MDateUtil.toDate(dateStr);
        tmp.setDate(1);
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    //每个月最后一天
    lastDayOfMonth:function(dateStr){
        var tmp = (arguments.length==0) ? MDateUtil.today() : dateStr;
        tmp = MDateUtil.addMonths(1,tmp);
        tmp = MDateUtil.firstDayOfMonth(tmp);
        tmp = MDateUtil.addDays(-1,tmp);
        return tmp;
    },
    //添加一个月后的第一天
    addMonthsForStart:function(month,dateStr){
        var tmp = (arguments.length==1) ? MDateUtil.today() : dateStr;
        tmp = MDateUtil.addMonths(month,tmp);
        return MDateUtil.firstDayOfMonth(tmp);
    },
    addMonthsForEnd:function(month,dateStr){
        var tmp = (arguments.length==1) ? MDateUtil.today() : dateStr;
        tmp = MDateUtil.addMonths(month,tmp);
        var tt = MDateUtil.firstDayOfMonth(tmp);
        return MDateUtil.addDays(-1, MDateUtil.firstDayOfMonth(tmp));
    },
    addYears:function(year,dateStr){
        var tmp = (arguments.length==1) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp.setYear(tmp.getYear()+parseInt(year));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    firstDayOfYear:function(dateStr){
        var tmp = (arguments.length==0) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp.setMonth(0);
        tmp.setDate(1);
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    addYearsForStart:function(year,dateStr){
        var tmp = (arguments.length==1) ? MDateUtil.today() : dateStr;
        tmp = MDateUtil.addYears(year,tmp);
        return MDateUtil.firstDayOfYear(tmp);
    },
    addYearsForEnd:function(year,dateStr){
        var tmp = (arguments.length==1) ? MDateUtil.today() : dateStr;
        tmp = MDateUtil.addYears(year,tmp);
        return MDateUtil.firstDayOfYear(tmp);
    },
    sunOfWeek:function(dateStr){
        var tmp  = (arguments.length ==0) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp = new Date(tmp - (tmp.getDay()) * (24 * 3600 * 1000));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    monOfWeek:function(dateStr){
        var tmp = (arguments.length == 0) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp = new Date(tmp - (tmp.getDay() - 1) * (24 * 3600 * 1000));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    tueOfWeek:function(dateStr){
        var tmp = (arguments.length == 0) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp = new Date(tmp - (tmp.getDay() - 2) * (24 * 3600 * 1000));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    wedOfWeek:function(dateStr){
        var tmp = (arguments.length == 0) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp = new Date(tmp - (tmp.getDay() - 3) * (24 * 3600 * 1000));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    turOfWeek:function(dateStr){
        var tmp = (arguments.length == 0) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp = new Date(tmp - (tmp.getDay() - 4) * (24 * 3600 * 1000));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    friOfWeek:function(dateStr){
        var tmp = (arguments.length == 0) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp = new Date(tmp - (tmp.getDay() - 5) * (24 * 3600 * 1000));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    },
    satOfWeek:function(dateStr){
        var tmp = (arguments.length == 0) ? MDateUtil.toDate(MDateUtil.today()) : MDateUtil.toDate(dateStr);
        tmp = new Date(tmp - (tmp.getDay() - 6) * (24 * 3600 * 1000));
        return MDateUtil.toString(tmp,"yyyy-MM-dd HH:mm:ss");
    }
};
const getClientIP = {
    getIntnetIP: function () {
        let JSONP = document.createElement("script");
        JSONP.type = "text/javascript";
        JSONP.src = "http://chaxun.1616.net/s.php?type=ip&v=&output=json&callback=jsonpCallback";
        document.getElementsByTagName("head")[0].appendChild(JSONP);
    }
};
//加密解密
// const Encrypt = {
//     encode:function (input) {
//         let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
//         let output = "";
//         let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
//         let i = 0;
//         input = _utf8_encode(input);
//         while (i < input.length) {
//             chr1 = input.charCodeAt(i++);
//             chr2 = input.charCodeAt(i++);
//             chr3 = input.charCodeAt(i++);
//             enc1 = chr1 >> 2;
//             enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
//             enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
//             enc4 = chr3 & 63;
//             if (isNaN(chr2)) {
//                 enc3 = enc4 = 64;
//             } else if (isNaN(chr3)) {
//                 enc4 = 64;
//             }
//             output = output +
//               _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
//               _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
//         }
//         return output;
//     },
//     decode:function (input) {
//         let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
//         let output = "";
//         let chr1, chr2, chr3;
//         let enc1, enc2, enc3, enc4;
//         let i = 0;
//         input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
//         while (i < input.length) {
//             enc1 = _keyStr.indexOf(input.charAt(i++));
//             enc2 = _keyStr.indexOf(input.charAt(i++));
//             enc3 = _keyStr.indexOf(input.charAt(i++));
//             enc4 = _keyStr.indexOf(input.charAt(i++));
//             chr1 = (enc1 << 2) | (enc2 >> 4);
//             chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
//             chr3 = ((enc3 & 3) << 6) | enc4;
//             output = output + String.fromCharCode(chr1);
//             if (enc3 != 64) {
//                 output = output + String.fromCharCode(chr2);
//             }
//             if (enc4 != 64) {
//                 output = output + String.fromCharCode(chr3);
//             }
//         }
//         output = _utf8_decode(output);
//         return output;
//     },
//     _utf8_encode:function (string) {
//         string = string.replace(/\r\n/g,"\n");
//         var utftext = "";
//         for (var n = 0; n < string.length; n++) {
//             var c = string.charCodeAt(n);
//             if (c < 128) {
//                 utftext += String.fromCharCode(c);
//             } else if((c > 127) && (c < 2048)) {
//                 utftext += String.fromCharCode((c >> 6) | 192);
//                 utftext += String.fromCharCode((c & 63) | 128);
//             } else {
//                 utftext += String.fromCharCode((c >> 12) | 224);
//                 utftext += String.fromCharCode(((c >> 6) & 63) | 128);
//                 utftext += String.fromCharCode((c & 63) | 128);
//             }
//
//         }
//         return utftext;
//     },
//     _utf8_decode:function (utftext) {
//         var string = "";
//         var i = 0;
//         var c = c1 = c2 = 0;
//         while ( i < utftext.length ) {
//             c = utftext.charCodeAt(i);
//             if (c < 128) {
//                 string += String.fromCharCode(c);
//                 i++;
//             } else if((c > 191) && (c < 224)) {
//                 c2 = utftext.charCodeAt(i+1);
//                 string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
//                 i += 2;
//             } else {
//                 c2 = utftext.charCodeAt(i+1);
//                 c3 = utftext.charCodeAt(i+2);
//                 string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
//                 i += 3;
//             }
//         }
//         return string;
//     }
// }
const Encrypt=function (){
    // private property
    this._keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    // public method for encoding
    this.encode = function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = _utf8_encode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output +
              this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
              this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
        }
        return output;
    }

    // public method for decoding
    this.decode = function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
            enc1 = _keyStr.indexOf(input.charAt(i++));
            enc2 = _keyStr.indexOf(input.charAt(i++));
            enc3 = _keyStr.indexOf(input.charAt(i++));
            enc4 = _keyStr.indexOf(input.charAt(i++));
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }
        output = _utf8_decode(output);
        return output;
    }
    // private method for UTF-8 encoding
    let _utf8_encode = function (string) {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }
        return utftext;
    }

    // private method for UTF-8 decoding
    let _utf8_decode = function (utftext) {
        var string = "";
        var i = 0;
        var c = c1 = c2 = 0;
        while ( i < utftext.length ) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return string;
    }
};
export default {
    string: generalUtil,
    object: objectUtil,
    getClientIP:getClientIP,
    browser:MBrowserUtil(),
    localstorage:MLocalStorageUtil(),
    sessionStorage:MSessionStorageUtil(),
    cookie:MCookieUtil,
    date:MDateUtil,
    Encrypt:new Encrypt()
    // TimeStampConvertTime:TimeStampConvertTime
}


// WEBPACK FOOTER //
// ./src/assets/js/util.js